import React from 'react';
import { Label, CheckBoxField,  ErrorMessage } from '../FormikCustom';

export default function CheckBox({ name, label, required, forceError, ...rest }) {
  const fieldProps = { ...rest };
  if (forceError !== undefined) {
    fieldProps.forceError = forceError;
  }
  return (
    <div className="checkbox" >
        <Label required={required} style={{fontWeight:700}}>
              <CheckBoxField name={name}  {...fieldProps} />
              {label}
        </Label>
      <ErrorMessage name={name} />
    </div>
  );
}
